import { RematchDispatch, RematchRootState } from '@rematch/core';
import { connect } from 'react-redux';
import { RootModel } from '../../../../state';
import { NamedVersionSelectionContainer } from './NamedVersionSelectionContainer';

export const mapState = (state: RematchRootState<RootModel>) => ({
  iModelId: state.imodels.iModel.iModelId,
  selected: state.imodels.iModel.namedVersionId,
});

export const mapDispatch = (dispatch: RematchDispatch<RootModel>) => ({
  setNamedVersionId: (namedVersionId: string) =>
    dispatch.imodels.setNamedVersionId(namedVersionId),
});

export const ConnectedNamedVersionSelection = connect(
  mapState,
  mapDispatch
)(NamedVersionSelectionContainer);
